import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtGetEquityInvestmentDetailAssetRecord } from "@/services/cms/customer";
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      listRequest: rqtGetEquityInvestmentDetailAssetRecord,
      searchForm: {
        id: null,
        pid: null
      }
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    let productId = this.$route.params.productId;
    let customerId = this.$route.params.customerId;
    if (productId && customerId) {
      this.searchForm.pid = productId;
      this.searchForm.id = customerId;
      this.init(productId, customerId);
    }
  },
  methods: {
    init(productId, customerId) {
      console.log("页面参数：", productId, customerId);
      this.$refs['ListViewCpt'].initListData();
    }
  }
};